import moment from "moment";
import { Vaccine } from "../../types";
import { useCallback } from "react";
import { Badge, BadgeSize, BadgeVariant } from "shared/components";

interface VaccinationTableProps {
  vaccines: Vaccine[];
}

export const VaccinationTable = ({ vaccines }: VaccinationTableProps) => {
  const isExpired = useCallback((expirationDate: string) => {
    return moment(expirationDate).isBefore(moment());
  }, []);

  if (!vaccines.length) return null;

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-content-50">
        <thead>
          <tr>
            <th className="text-left text-sm font-medium text-content-300 p-2">
              Vaccination
            </th>
            <th className="text-left text-sm font-medium text-content-300 p-2">
              Vaccination date
            </th>
            <th className="text-left text-sm font-medium text-content-300 p-2">
              Expiration date
            </th>
            <th className="text-left text-sm font-medium text-content-300 p-2"></th>
          </tr>
        </thead>
        <tbody className="divide-y divide-content-50">
          {vaccines.length
            ? vaccines.map((vaccine, index) => {
                const isVaccineExpired = isExpired(vaccine.expirationDate);

                return (
                  <tr key={index} className="bg-white">
                    <td className="p-2 text-sm text-content-1000">
                      {vaccine.name}
                    </td>
                    <td className="p-2 text-sm text-content-300">
                      {vaccine.vaccinationDate}
                    </td>
                    <td className="p-2 text-sm text-content-300 flex items-center gap-2">
                      {vaccine.expirationDate}
                    </td>
                    <td className="p-2 text-sm text-content-300">
                      <Badge
                        className="shrink-0 items-center"
                        size={BadgeSize.SM}
                        variant={
                          isVaccineExpired
                            ? BadgeVariant.BASE
                            : BadgeVariant.SUCCESS
                        }
                      >
                        {isVaccineExpired ? "Expired" : "Active"}
                      </Badge>
                    </td>
                  </tr>
                );
              })
            : null}
        </tbody>
      </table>
    </div>
  );
};
